import { getServices } from '~/db/services';

import { NomadDB } from '~/db/NomadDB';

export enum DeepLinkActions {
  SignUp = 'signUp',
  TokenAuth = 'tokenAuth', // nok
  AppShare = 'appShare', // nok
  Share = 'share', // nok + param subscriptionRequestParents // nok
  StudyTab = 'studyTab', // + id ok
  Categories = 'categories', // + id ok
  CategoryByTitle = 'categorybytitle', // + title ok
  Discipline = 'discipline', // ok
  Exercises = 'exercises', // ok
  DailyQuiz = 'dailyQuiz', // ok
  Posts = 'posts', // /posts/{postId} ok
  Adventure = 'adventure', // do nothing
  Agenda = 'agenda', // nok
  Events = 'events', //  /events/{eventId} nok
  Nomadplus = 'nomadplus', // /nomadplus ok /nomadplus/{productid} nok
  Paywall = 'paywall', // /paywall ok /paywall/placements/{ID DU PLACEMENT} nok /paywall/presentations/{ID DU PAYWALL} nok
  LibraryBox = 'librarybox', // ok
  LibraryBoxTitle = 'libraryboxbytitle', // ok
  LibraryBook = 'librarybook', // ok
  LibraryBookByTitle = 'librarybookbytitle', // ok
  Family = 'family', // /family ok  /family/invitation/{invitationCode} nok /addMember nok
  Childinviteparent = '/childinviteparent', // nok
  SponsorInfos = 'sponsorinfos', // /sponsorinfos nok /sponsorinfos/{sponsorInfosId} nok /sponsorinfos/{sponsorInfoId}/content/{sectionId} nok
  Coaching = 'coaching', // nok
  // Result = 'result', // Pas dispo dans BBS, seulement dans Puissance Alpha / Concours avenir
  MyFutureBox = 'myfuturebox', // nok
  Training = 'training', // nok
  SchoolBasket = 'schoolBasket', // nok
  Menu = 'menu', // nok
  Profile = 'profile', // ok
  MemberRanking = 'memberRanking', // nok
  GradeSimulator = 'gradeSimulator', // ok
  Championship = 'championship', // nok
  Trophies = 'trophies', // ok
  Challenges = 'challenges', // /challenges nok /challenges/{id} nok
  GamingRoom = 'gamingRoom', // ok
  GamingLevels = 'gamingLevels', // ok
  GamingStreak = 'gamingStreak', // ok
  ForYou = 'forYou', // ok
  Profiling = 'profiling',
  Settings = 'settings', // /settings nok /settings/{boxName} nok
  AppRating = 'appRating',
  Kiosque = 'kiosque', // nok
  Game = 'game', // nok
  Support = 'support', // ok
  Faq = 'faq', // ok
  Referral = 'referral', // /referral nok /referral/{code} nok
  SchoolContactAcceptance = 'schoolContactAcceptance', // nok
  Feed = 'feed', // /feed nok / /feed/{type} nok
  Friend = 'friend', // /friend nok /friend/feeds nok /friends/list nok /friends/add nok /friend/invitation/{b64:invitingMemberId} nok
  Surveys = 'surveys', // /surveys /surveys/{exerciseId} nok
  GiftCode = 'giftCode', // nok
  Browser = 'browser', // nok
  AuthorizationNotifications = 'authorizationNotifications', // nok
  AppSettings = 'appSettings',
  Search = 'search', // ok /study /study/ma recherche
}

export type DeeplinkRedirect = {
  type: DeepLinkActions;
  path?: string;
};

export const getIsDeepLink = (category: CategorySchema) => {
  return category.deeplink != null && category.deeplink.length > 0;
};

export const categoryDeepLinkParser = async (
  $db: NomadDB,
  category: CategorySchema,
  allContents: UserContent[],
  mainContent: UserContent,
  isHome: boolean
) => {
  const { deeplink, deeplinkRedirect } = category;
  if (!deeplink) return null;
  if (deeplinkRedirect) return deeplinkRedirect;
  const { categoriesService } = getServices($db);
  const redirect = await deepLinkParser(
    $db,
    deeplink,
    allContents,
    mainContent,
    isHome
  );
  category.deeplinkRedirect = redirect;
  await categoriesService.update(category, { deeplinkRedirect: redirect });

  return redirect;
};

export const getDeeplinkFromContinue = (ctn: string) => {
  const prts = ctn.split('nomadeducation-nomadeducation://');
  if (prts.length < 2) return;
  return prts[1].split('&')[0];
};

export const getDeepLinkActionParams = (deeplink: string) => {
  let webDeeplink = toValue(deeplink).replace(
    'nomadeducation-nomadeducation://',
    ''
  );

  webDeeplink = `https://${webDeeplink}`;

  const deeplinkURL: URL = new URL(webDeeplink);

  const ctxSym = Object.getOwnPropertySymbols(deeplinkURL).find(
    (s) => s.description === 'context'
  );

  const [action, ...params] =
    deeplinkURL[ctxSym]?.path ||
    deeplinkURL.pathname.replace('/', '').split('/');

  return {
    action,
    params,
  };
};

export const deepLinkParser = async (
  $db: NomadDB,
  deeplink: string,
  allContents: UserContent[],
  mainContent: UserContent,
  isHome: boolean
): Promise<DeeplinkRedirect> => {
  if (!deeplink) return null;

  const {
    categoriesService,
    libraryBooksService,
    librariesService,
    exercisesService,
    postsService,
  } = getServices($db);

  const { action, params } = getDeepLinkActionParams(deeplink);

  const redirect: DeeplinkRedirect = {
    type: action as DeepLinkActions,
    path: null,
  };

  const { getQuery } = useSearchRoute();

  switch (action) {
    case DeepLinkActions.Search: {
      if (params && params.length && params[0] === 'study') {
        let q = '';
        if (params.length > 1) {
          q = params[1];
        }
        const query = getQuery(q, mainContent?.algoliaGeoloc || null, []);
        redirect.path = `/revisions/recherche?${toQueryString(query)}`;
      }
      break;
    }

    case DeepLinkActions.SignUp: {
      redirect.path = `/signup`;
      break;
    }

    case DeepLinkActions.Nomadplus: {
      redirect.path = `/nomad`;
      break;
    }

    case DeepLinkActions.Settings: {
      const path = window?.location?.pathname || '';
      const basePath = path === '/redirect' ? '/mon-compte' : '';
      if (params && params.length) {
        redirect.path = `${basePath}#/settings/${params[0]}`;
      } else {
        redirect.path = `${basePath}#/settings`;
      }
      break;
    }

    case DeepLinkActions.GradeSimulator: {
      redirect.path = `/revisions/simulateur-de-notes`;
      if (params && params.length) {
        const [id, values] = params;
        if (id) {
          redirect.path += `/${id}`;
          if (values) {
            redirect.path += `?values=${values}`;
          }
        }
      }

      break;
    }

    case DeepLinkActions.Profiling: {
      redirect.path = `/mon-compte/modifier-mon-profil`;
      break;
    }

    case DeepLinkActions.Support:
    case DeepLinkActions.Faq: {
      redirect.path = `https://support.nomadeducation.fr/fr/`;
      break;
    }

    case DeepLinkActions.DailyQuiz: {
      const category: CategorySchema =
        await categoriesService.getByContentTypesAndLb(
          [ContentTypes.InterDisciplineDailyQuiz],
          mainContent.id
        );
      if (category) {
        redirect.path = `/${Sections.InTheNews}/${mainContent.slug}/${category.slug}/exercise/quiz-du-jour`;
      }
      break;
    }

    case DeepLinkActions.Posts: {
      const id = params[0];
      const posts: PostSchema[] = await postsService.findByIds([id]);

      if (posts.length) {
        const post = posts[0];
        const parents = post?.categories || [];
        const parentIds = parents.map((cat) => cat.id);
        const categories = await categoriesService.findByIds(parentIds);
        const contagoryFromMainLb = categories.find(
          (cat) => cat.libraryBookId === mainContent.id
        );
        if (contagoryFromMainLb) {
          redirect.path = `/${mainContent.baseSection}/${mainContent.slug}/${contagoryFromMainLb.slug}/post/${post.slug}`;
        } else {
          const category = categories[0];
          const content = allContents.find(
            (content) => category.libraryBookId === content.id
          );
          redirect.path = `/${content.baseSection}/${content.slug}/${category.slug}/post/${post.slug}`;
        }
      }
      break;
    }

    case DeepLinkActions.Exercises: {
      const id = params[0];
      const exercises: ExerciseSchema[] = await exercisesService.findByIds([
        id,
      ]);

      if (exercises.length) {
        const exercise = exercises[0];
        const { parentId, libraryBookId } = exercise;
        const categories: CategorySchema[] =
          await categoriesService.findByIdsAndLibraryBookId(
            [parentId],
            libraryBookId
          );
        if (categories.length) {
          const category = categories[0];
          const content = allContents.find(
            (content) => category.libraryBookId === content.id
          );
          if (content) {
            redirect.path = `/${content.baseSection}/${content.slug}/${category.slug}/exercise/${exercise.slug}`;
          }
        }
      }
      break;
    }

    case DeepLinkActions.Categories:
    case DeepLinkActions.Discipline:
    case DeepLinkActions.CategoryByTitle: {
      let categories: CategorySchema[];

      if (action === DeepLinkActions.Categories) {
        const id = params[0];
        categories = await categoriesService.findByIds([id]);
      } else {
        const title = decodeURIComponent(atob(params[0]));
        categories = await categoriesService.findByTitle(title);
      }

      if (categories.length) {
        let section = 'revisions';
        const categoryFromMainContent = categories.find(
          (cat) => cat.libraryBookId === mainContent.id
        );
        if (categoryFromMainContent) {
          if (isHome) {
            section = Sections.InTheNews;
          } else {
            section = mainContent.baseSection;
          }
          redirect.path = `/${section}/${mainContent.slug}/${categoryFromMainContent.slug}`;
        } else {
          const category = categories[0];
          const content = allContents.find(
            (content) => category.libraryBookId === content.id
          );
          if (content) {
            redirect.path = `/${content.baseSection}/${content.slug}/${category.slug}`;
          }
        }
      }
      break;
    }

    case DeepLinkActions.LibraryBook: {
      const lib = await libraryBooksService.get({
        id: params[0],
      });
      if (lib?.slug) {
        redirect.path = `/nomad/${lib.slug}`;
      }
      break;
    }

    case DeepLinkActions.Profile: {
      redirect.path = `/mon-compte`;
      break;
    }

    case DeepLinkActions.LibraryBookByTitle: {
      const title = decodeURIComponent(atob(params[0]));
      const lib = await libraryBooksService.get({
        metaTitle: title,
      });
      if (lib?.slug) {
        redirect.path = `/nomad/${lib.slug}`;
      }
      break;
    }

    case DeepLinkActions.LibraryBox: {
      const lib = await librariesService.get({ id: params[0] });
      if (lib?.slug) {
        redirect.path = `/nomad/${lib.slug}`;
      }
      break;
    }

    case DeepLinkActions.LibraryBoxTitle: {
      const title = decodeURIComponent(atob(params[0]));
      // try {
      const lib = await librariesService.get({ title });
      if (lib?.slug) {
        if (globalThis.$logger)
          globalThis.$logger.info(
            'useDeepLinkParser :: ',
            DeepLinkActions.LibraryBoxTitle,
            'title found :',
            title
          );
        redirect.path = `/nomad/${lib.slug}`;
      } else if (globalThis.$logger)
        globalThis.$logger.error(
          'useDeepLinkParser :: ',
          DeepLinkActions.LibraryBoxTitle,
          'title not find :',
          title
        );

      break;
    }

    case DeepLinkActions.Family: {
      if (params && params.length) {
        redirect.path = `/famile?code=${params[0]}`;
      } else {
        redirect.path = `/famille`;
      }
      break;
    }

    case DeepLinkActions.StudyTab: {
      redirect.path = `/revisions`;
      break;
    }

    case DeepLinkActions.ForYou: {
      redirect.path = `/pour-toi`;
      break;
    }

    case DeepLinkActions.GamingStreak: {
      redirect.path = `/gaming#streak`;
      break;
    }

    case DeepLinkActions.GamingLevels: {
      redirect.path = `/gaming#level`;
      break;
    }

    case DeepLinkActions.GamingRoom: {
      redirect.path = `/gaming`;
      break;
    }

    case DeepLinkActions.Trophies: {
      redirect.path = `/gaming#trophees`;
      break;
    }

    case DeepLinkActions.Paywall: {
      redirect.path = `https://www.nomadeducation.fr/premium`;
      break;
    }

    case DeepLinkActions.SponsorInfos: {
      if (!params?.length) {
        redirect.path = `https://www.nomadeducation.fr/orientation`;
      }
      break;
    }

    case DeepLinkActions.Share:
    case DeepLinkActions.Adventure: {
      // not managed
      break;
    }
  }

  return redirect;
};
